import { Hasher } from "@iden3/js-jsonld-merklization";
import { poseidon } from "@iden3/js-crypto";
// import { keccak256 } from 'js-sha3';
import { Hex } from '@iden3/js-crypto';
import { keccak256 } from '@lumeweb/js-sha3-browser';

export class CustomHasher implements Hasher {
  async hash(inpBI: bigint[]): Promise<bigint> {
    return poseidon.hash(inpBI);
  }

  async hashBytes(msg: Uint8Array): Promise<bigint> {
    return poseidon.hashBytesX(msg, 6);
  }

  prime(): bigint {
    return BigInt(
      "21888242871839275222246405745257275088548364400416034343698204186575808495617"
    );
  }
}

export class Keccak256Hasher implements Hasher {
  toByteArray(bigNumber: bigint): Uint8Array {
    const n256 = BigInt(256);
    let result = new Uint8Array();
    while (bigNumber > BigInt(0)) {
      result = new Uint8Array([ ...result, Number(bigNumber % n256)]);
      bigNumber = bigNumber / n256;
    }
    return result.reverse();
  }
  fromByteArray(bb: Uint8Array):bigint{
    bb = bb.reverse();
    const n256 = BigInt(256);
    let result = BigInt(0);
    let base = BigInt(1);
    bb.forEach((byte) => {
      result += base * BigInt(byte);
      base = base * n256;
    });
    return result;
  }

  async hash(inpBI: bigint[]): Promise<bigint> {

    var inpBytes = new Uint8Array();

    inpBI.forEach(i => {
      const bb =  this.toByteArray(i);
      inpBytes =  new Uint8Array([ ...inpBytes, ...bb ]);
    });

    let hash =  keccak256(inpBytes);

    // Convert the hash bytes to a big integer
    let i = this.fromByteArray(Hex.decodeString(hash));

    return i % this.prime();
  }


  async hashBytes(msg: Uint8Array): Promise<bigint> {
    const hash = keccak256(msg);
    const i = BigInt(`0x${hash}`);
    return  i % this.prime();

  }

  prime(): bigint {
    return BigInt(
        '21888242871839275222246405745257275088548364400416034343698204186575808495617'
    );
  }
}